module.exports = __webpack_public_path__ + "3d72339e1438aa95f62c169e326ba6b4.pdf";